const clientReport = {
  clientReports: 'Звіт клієнта',
  showing: 'показується',
  clientReportsOf: 'клієнти',
  noClientReportsFound: 'Звітів клієнтів не знайдено',
};

export default clientReport;
